<section class="header">
  <div class="text-right " style="border: 10px solid gray; background-color: gray; margin-bottom: 1em;">
    <span style="background-color: gray; color: white;">{{ userInfo?.firstName }}  |  <a (click)="logout()" class="logout-text">Logout</a></span>
  </div>
  <div class="cont">
    <div class="row">
      <div class="col-sm-4">
        <img src="{{imagePath}}" alt="logo">
      </div>
    </div>
  </div>
</section><main role="main" class="container">

  <div *ngIf="result" style="background-color: lightblue;">
    Status code: {{statusCode}}
    <br />
    Response: <a href="{{result}}">{{result}}</a>
    <br />
  </div>

<br />


<form [formGroup]="registerActivity">
  <p>Click to simulate purchasing from E-Store</p>
  <div class="form-group">
      <label for="kit"><em style="color:red">* </em><strong>LMS Activity Id</strong></label>
      <input type="text" id="activityId" formControlName="activityId" style="margin-left: 1em;">
  </div>
  <button class="btn_full" type="submit" (click)="onSimulateRegister()">Register</button>
</form>

</main>
<app-footer></app-footer>

